import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("Page crashed", error, info); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="page-error" className="card-n p-10 text-center space-y-4">
        <p className="font-display text-2xl">Something went wrong on this page</p>
        <p className="text-sm text-slate-400">{String(this.state.error?.message || this.state.error)}</p>
        <button onClick={() => this.setState({ error: null })} className="px-5 py-2 rounded-full bg-orange-500 text-white text-sm">Try again</button>
      </div>
    );
  }
}
